import styled, { DefaultTheme } from "styled-components";

export const Container = styled.div<{ theme: DefaultTheme }>(({ theme }) => ({
  backgroundColor: theme.kallisto.color.background.static.backgroundLayer01,
  padding: "1rem",
  borderRadius: "8px",
}));

export const FilterTitle = styled.div<{ theme: DefaultTheme }>(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  svg: {
    fill: theme.kallisto.color.text.interactive.textPrimaryDefault,
  },
}));
